<template>
    <div>
        <div class="header" :class="{active:header}">
            <van-icon name="arrow-left" class="icons" @click="fanhui" />
            <span class="title">{{ title }}</span>
            <span class="right"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: () => {
                return String;
            },
        },
        header: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
        id: {
            type: String,
            default: () => {
                return "";
            },
        },
    },
    data() {
        return {};
    },
    created() { },
    methods: {
        fanhui() {
            if (this.id == "MyShop") {
                this.$router.push({
                    name: "MyShop",
                });
            } else {
                this.$router.back();
            }
        },
    },
    mounted() { },
};
</script>
<style lang="scss" scoped>
@import "../scss/index.scss";

.header {
    @extend .flex;
    @include positionTop(0,0,0);
    width: 100%;
    height: 5rem;
    justify-content: space-between;
    background:url('../../assets/img/head.png');
    background-size: 100%;
    color: $titleHeadColor;
    padding: 0 1rem;
    z-index: 99;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);

    .icons {
        font-size: 2rem;
    }

    .title {
        font-size: 1.8rem;
    }

    .right {
        padding: 1rem;
    }
}
.active{
    background: linear-gradient(0deg, #08c271,#49de9d);;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/common/vue/head.vue